import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STMethodClassificationComponent from "../../../api/StationaryTesting/STMethodClassification";
import STMethodClassificationForm from "./STMethodClassificationForm";
import { getMessage } from "../../../global";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});

const STMethodClassification = (props) => {

    const initialStateMethod = {
        id: undefined,
        classificationName: "",
        isActive: false,
    };

    const validationsInitialState =
    {
        methodName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateMethod);
    const [methodList, setMethodList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveMethod();
            else {

                STMethodClassificationComponent.get(infoData.classificationName).then((methodExists) => {
                    if ((methodExists !== undefined && methodExists !== null))
                        openModalSimpleButton('Fail', 'This method classification already exist', 'Ok');
                    else saveMethod();
                });
            }
        }
    }

    function saveMethod() {

        let method = new STMethodClassificationComponent({
            classificationName: infoData.classificationName,
            isActive: infoData.isActive
        });

        if (infoData.id === undefined) {
            STMethodClassificationComponent.add(method).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Method classification saved with success', 'Ok');
                    loadMethodFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STMethodClassificationComponent.update(method).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Method classification updated with success', 'Ok');
                    loadMethodFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadMethodFilter() {
        STMethodClassificationComponent.getAll().then((res) => {
            if (res.length > 0) {

                let array = [];
                array.push({ id: undefined, classificationName: "" });
                array.push(...res);

                setMethodList(array);
            }
        });
    }

    function validateFields() {
        let requiredMethodName = infoData.classificationName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            methodName: requiredMethodName
        });

        return ((requiredMethodName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateMethod);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTMethodFilter(idSelected) {
        setInfoData(initialStateMethod);

        setInfoData(() => ({
            ...initialStateMethod,
            id: idSelected,
            classificationName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STMethodClassificationComponent.get(idSelected).then((method) => {
                if (method !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        classificationName: method.classificationName,
                        isActive: method.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (methodList === null) {
            loadMethodFilter();
        }
    }, [methodList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading Method Classification..."}
                                        value={infoData.classificationName === '' ? null : infoData.classificationName}
                                        onChange={(e, value) => {
                                            handleChangeSTMethodFilter(value);
                                        }}
                                        disablePortal
                                        options={methodList ? methodList.map((method) => method.classificationName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="Method Classification" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STMethodClassificationForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTMethodFilter={handleChangeSTMethodFilter}
                            canEdit={canEdit}
                        >
                        </STMethodClassificationForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STMethodClassification;